import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { func, bool, arrayOf, shape, string } from "prop-types";
import classNames from "classnames";

import { Box } from "@ui-kit/components/index.es";

import * as i18n from "util/i18n";
import { FORM_ID } from "constants/servicePayments";

import Button from "pages/_components/Button";
import Productselector from "pages/forms/_components/_fields/Productselector";
import SelectedAccountsAmount from "pages/charges/_components/SelectedAccountsAmount";

import { actions as servicePaymentsActions } from "reducers/servicePayments";
import { connect } from "react-redux";

const MultiplePaymentsHeader = (props) => {
    const {
        isDesktop,
        accounts,
        submitForm,
        disableButton,
        payments,
        currencies,
        setErrors,
        setTouched,
        dispatch,
        defaultAccount,
    } = props;
    const [selectedAccount, setSelectedAccount] = useState(null);
    const accountsArs = accounts?.filter((account) => account.currency === currencies[0].id.toString());

    useEffect(() => {
        const selAccount = accountsArs.find((account) => account.idProduct === defaultAccount || account.favorite);
        if (selAccount) {
            setSelectedAccount(selAccount);
            dispatch(servicePaymentsActions.setMultiplePaymentsAccount(selAccount));
        }
    }, [dispatch, defaultAccount]);

    const onChangeAccount = (account) => {
        const selAccount = accountsArs.find((object) => object.idProduct === account);
        if (selAccount) {
            setSelectedAccount(selAccount);
            dispatch(servicePaymentsActions.setMultiplePaymentsAccount(selAccount));
        }
    };

    const accountSelector = (
        <Field
            name="account"
            component={Productselector}
            idField="account"
            idForm={FORM_ID}
            data={{
                emptyOptionLabel: "",
                options: accountsArs,
            }}
            disabled={accountsArs.length === 0}
            mode="edit"
            isRequired
            defaultValue={defaultAccount || accountsArs.find((a) => a.favorite)?.idProduct}
            isDesktop={isDesktop}
            labelText="transfers.debitaccount.label"
            customPlaceholder={i18n.get("payments.afip.list.generatedVEP.placeholder")}
            onCustomChange={onChangeAccount}
        />
    );

    const summaryAndPay = (
        <>
            <div
                className={classNames(
                    "d-flex flex-column justify-content-center text-uppercase pr-3",
                    isDesktop ? "text-right" : "text-left",
                )}>
                <SelectedAccountsAmount
                    list={payments?.filter(({ isChecked }) => isChecked)}
                    withoutTables
                    leftOperations={false}
                    selectedAccount={selectedAccount}
                    setErrors={setErrors}
                    setTouched={setTouched}
                />
            </div>
            <div className="align-items-center d-flex">
                <Button
                    block={false}
                    label={`${FORM_ID}.paySelected`}
                    bsStyle="primary"
                    onClick={submitForm}
                    disabled={disableButton}
                    className={isDesktop && "no-wrap"}
                />
            </div>
        </>
    );

    return (
        <Box
            w="100%"
            align="center"
            justify="between"
            py={8}
            px={!isDesktop ? 16 : 0}
            css={{ flexDirection: isDesktop ? "row" : "column-reverse" }}>
            <Box py={8} w={isDesktop ? "300px" : "100%"}>
                {accountSelector}
            </Box>
            <Box align="center">{summaryAndPay}</Box>
        </Box>
    );
};

MultiplePaymentsHeader.propTypes = {
    isDesktop: bool.isRequired,
    dispatch: func.isRequired,
    accounts: arrayOf(
        shape({
            idProduct: string.isRequired,
        }),
    ).isRequired,
    submitForm: func.isRequired,
    disableButton: bool.isRequired,
    payments: arrayOf(shape({})).isRequired,
    currencies: arrayOf(
        shape({
            id: string.isRequired,
        }),
    ).isRequired,
    setErrors: func.isRequired,
    setTouched: func.isRequired,
    defaultAccount: string.isRequired,
};

export default connect()(MultiplePaymentsHeader);
